export var GOLD = '#F4D316';
export var ORANGE = '#FF9900';
export var RED = '#E53935';
export var GREEN = '#47B04B';
export var LIGHT_GREY = '#C5C8CC';
export var GREY = '#777777';
export var BLUE = '#4571BA';
export var LIGHT_GREEN = '#99D29B';
export var LIGHT_BLUE = '#ABC0E0';